module.exports = __webpack_public_path__ + "images/setting_4.png";